import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  Box, VStack, Button,Menu,
  MenuButton,
  MenuList,
  MenuItem,
  useColorModeValue,
} from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as IconButton from '../themes/IconButtonSet';
import { faSquare, faChevronDown} from '@fortawesome/free-solid-svg-icons';

const Sidebar = ({ isOpen, bgColor }) => {
    const menuItems = [
      { label: "หน้าแรก", path: "/home", icon: faSquare },
      { label: "จองวัคซีน", path: "/vaccinereservationlist", icon: faSquare },
      { label: "ข้อมูลวัคซีน", path: "/vaccineinfo", icon: faSquare },
      { label: "ข้อมูลโรค", path: "/diceaseinfo", icon: faSquare },
      { label: "จุดจำหน่ายวัคซีน", path: "/distributionpoint", icon: faSquare },
    ];

    const handleMenuClick = (path) => {
      window.location.href = path;
    };

  return (
    <Box
      position="fixed"
      top="150px"
      left="0"
      h={isOpen ? "calc(100% - 86px)" : "0px"} // Adjust based on the header height
      bg={bgColor}
      w={isOpen ? "250px" : "0px"}
      transition="left 0.3s"
      zIndex="docked"
      shadow="md"
      overflow="hidden"
    >
      <VStack align="stretch" spacing={1} p={2}>
      {menuItems.map((item, index) => (
          <Menu key={index}>
            <MenuButton
              width="150px"
              as={Button}
              borderRadius="full"
              colorScheme="topmenuScheme"
              rightIcon={item.subMenu ? <FontAwesomeIcon icon={faChevronDown} /> : null}
              onClick={() => !item.subMenu && handleMenuClick(item.path)}
            >
              {item.label}
            </MenuButton>
            {item.subMenu && (
              <MenuList>
                {item.subMenu.map((subItem, subIndex) => (
                  <MenuItem key={subIndex} onClick={() => handleMenuClick(subItem.path)}>
                    {subItem.label}
                  </MenuItem>
                ))}
              </MenuList>
            )}
          </Menu>
        ))}
      </VStack>
    </Box>
  );
};

export default Sidebar;